/**
 * API统一出口
 * 页面中引入方式：import { getBanners, getGoodsDetail } from '@/api'
 */
import * as commonapi from './common'
import * as homeapi from './home'
import * as goodsapi from './goods'
import * as userapi from './user'
import * as cartapi from './cart'
import * as orderapi from './order'
import * as liveapi from './live'
import * as categoryapi from './category'
import * as addressapi from './address'
import * as refundapi from './refund'
import * as chatapi from './chat'

export default {
    category:categoryapi,
    common:commonapi,
    home:homeapi,
    goods:goodsapi,
    user:userapi,
    cart:cartapi,
    order:orderapi,
    live:liveapi,
    address:addressapi,
    refund:refundapi,
    chat:chatapi
}
